<template>
<div class="title_tab-container">
  <p class="title_tab" >{{ $t('ro_cogeneracion.titulo') }} {{ $t('ro_cogeneracion.cogeneracion') }} </p>

  <hr class="title_tab-divider">
</div>
<br>
  <v-row align="center" class="mb-4">
            <v-col cols="7">
 <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
            </v-col>
  </v-row>

 <!--      <div>
        <h2 style="text-decoration: underline;">{{ $t('ro_cogeneracion.titulo') }}</h2>
        
      </div> -->
<v-row>
  <v-col cols="5">
  <!-- Tabla de Ro Cogeneración -->
  <div class="contenedor-tabla">
    
    <div class="scroll-container">
      <table>
        <thead>
         <!--  <tr>
            <th colspan="9" class="cogeneracion-title">{{ $t('ro_cogeneracion.cogeneracion') }}</th>
          </tr>  -->
           <tr>
            <th rowspan="2" class="sticky-column encabezado_bold" >{{ $t('ro_cogeneracion.horizonte') }}</th>

          </tr>
          <tr>
            <th class="encabezado_bold" >
              {{ $t('ro_cogeneracion.valor_motores') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- .filter(([k]) =>k in mesesUnicos) -->
          <tr v-for="(valor, clave) in Object.fromEntries(
    Object.entries(localValue)
  )" :key="clave" class="tabla-hover">
          <td class="primera_columna sticky-column " >{{ clave }}</td>
          <td >
            <input type="number"
           
            v-model="localValue[clave]"
            @change="emitChange" />
          </td>
        </tr>

        </tbody>
      </table>
    </div>
  </div>
  </v-col>
  <v-col cols="1"></v-col>
  <v-col cols="5">
        <!-- Mensaje informativo -->
    <div class="backup-center">
    <v-alert
        type="info"
        variant="tonal"
        class="backup-alert"
    >
    <template #prepend>
      <div class="d-flex align-self-center" style="vertical-align: middle;"> 
        <v-icon size="24" color="#1776BF">mdi-information</v-icon>
    </div>
  </template>
  <span v-html="$t('mensajes.explicacion_ro')"></span>
    </v-alert>
    </div>
    </v-col>
    </v-row>
    <v-dialog v-model="showAlert" max-width="400">
                <v-card>
                    <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
                    <v-card-text>
                    {{ error_msg }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
</template>

<script>
import Papa from 'papaparse';
import Swal from 'sweetalert2';

const HEADERS_OFICIALES_RO = [
  'Horizonte',
  'Valor motores'
];
export default {
props: {
  modelValue: Object, // Recibe los datos desde el padre
  horizonte: Number,  // El horizonte de la simulación
  mesesUnicos:Object,
},
data() {
  return {
    motoresCogeneracion: [...Array(8)].map((_, i) => `cg${i + 1}.Ro`),
    showAlert:false,
    error_msg:"",
    localValue: { ...this.modelValue }
  };
},
computed: {
  roCogeneracionLocal: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    mesesUnicosFiltrados() {
      return this.roCogeneracionLocal.reduce((acc, item) => {
        if (!acc.some(row => row.horizonte === item.horizonte)) {
          acc.push({
            horizonte: item.horizonte,
            id: item.id,
            valor:item.valor,
            motores: item.motores,
            valores: item.valores
          });
        }
        return acc;
      }, []);
    }
  },
  watch: {
    modelValue:{
      handler(newValue){
        this.localValue= { ...newValue };
      }
    },

    /* horizonte: {
      handler(nuevoHorizonte, viejoHorizonte) {
        if (nuevoHorizonte !== viejoHorizonte) {
          this.$emit("generar-datos-ro", nuevoHorizonte);
        }
      }
    } */
  },
  
  methods: {
    toCsvDecimalComma(v, fixed = 2) {
    if (v === null || v === undefined || v === '') return '';
    let n = Number(v);
    if (Number.isNaN(n)) n = Number(String(v).replace(',', '.'));
    if (Number.isNaN(n)) return '';
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: fixed,
      maximumFractionDigits: fixed,
      useGrouping: false,
    });
  },
    emitChange() {
    this.$emit('update:modelValue', { ...this.localValue });
  },
    /*
    
    formatDecimal(value) {
      return value ? Number(value).toFixed(2) : "0.00"; // Muestra solo dos decimales sin modificar el valor real
    },
    updateParametro(index, motor, value) {
      const newValue = parseFloat(value); // Se guarda con precisión real
      if (!isNaN(newValue)) {
        this.roCogeneracionLocal[index].valores[motor] = newValue;
        this.emitChanges();
      }
    }*/
    importFromCSV() {
          this.$refs.fileInput.click();
    },
    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },

    normalizeHorizonte(raw) {
  if (raw == null) return '';
  // quita BOM, trim y minúsculas
  let s = String(raw).replace(/^\uFEFF/, '').trim().toLowerCase();

  // normaliza separadores a un espacio: "sep-25", "sep/25", "sep_25" -> "sep 25"
  s = s.replace(/[./_-]+/g, ' ').replace(/\s+/g, ' ').trim();

  // mapa meses a abreviatura canónica
  const mm = {
    'ene':'ene','enero':'ene',
    'feb':'feb','febrero':'feb',
    'mar':'mar','marzo':'mar',
    'abr':'abr','abril':'abr',
    'may':'may','mayo':'may',
    'jun':'jun','junio':'jun',
    'jul':'jul','julio':'jul',
    'ago':'ago','agosto':'ago',
    'sep':'sep','set':'sep','sept':'sep','septiembre':'sep',
    'oct':'oct','octubre':'oct',
    'nov':'nov','noviembre':'nov',
    'dic':'dic','diciembre':'dic'
  };

  const parts = s.split(' ');
  if (parts.length === 2) {
    let [mon, y] = parts;
    mon = mm[mon] || mon;
    if (/^\d{2}$/.test(y)) y = `20${y}`; // 25 -> 2025
    return `${mon} ${y}`;
  }
  return s;
},


findHorizonteKey(raw) {
  const wanted = this.normalizeHorizonte(raw);   // "sep 2025"
  const keys = Object.keys(this.localValue || {});
  // busca la clave original cuya normalización coincida
  const hit = keys.find(k => this.normalizeHorizonte(k) === wanted);
  return hit || null;
},
    handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon:'error', title:'Formato no válido', text:'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = e.target.result;

      Papa.parse(data, {
        delimiter: ';',          // estándar
        skipEmptyLines: true,
        header: true,            // exige cabeceras
        complete: (result) => {
          let rows = result.data || [];
          rows = rows.filter(r => Object.values(r).some(v => String(v ?? '').trim() !== ''));
          if (!rows.length) throw new Error('El CSV está vacío.');

          // validar cabeceras exactas y orden
          let headers = Object.keys(rows[0] || {});
          if (headers[0]) headers[0] = headers[0].replace(/^\uFEFF/, '');
          const sameLen = headers.length === HEADERS_OFICIALES_RO.length;
          const sameOrder = sameLen && HEADERS_OFICIALES_RO.every((h, i) => headers[i] === h);
          if (!sameOrder) throw new Error('El CSV no respeta la plantilla oficial (encabezados y orden).');

          const updated = { ...this.localValue };
          const missing = [];

          rows.forEach((row) => {
            const hCsvRaw = String(row['Horizonte']).trim();
            const hKey = this.findHorizonteKey(hCsvRaw); 

            if (!hKey) { 
              missing.push(hCsvRaw); 
              return; 
            }

            const val = this.parseNumber(row['Valor motores']);
            if (Number.isNaN(val)) {
              throw new Error(`Valor no numérico en 'Valor motores' para horizonte ${hCsvRaw}.`);
            }
            updated[hKey] = val; // interno con punto
          });

          if (missing.length) {
            throw new Error(`Horizontes no encontrados en la matriz: ${missing.slice(0,5).join(', ')}${missing.length>5?'…':''}`);
          }

          this.localValue = updated;
          this.emitChange();
          Swal.fire({ icon:'success', title:'Importación correcta', text:`${rows.length} registros actualizados.` });
        },
        error: () => { throw new Error('No se pudo leer el CSV.'); }
      });
    } catch (err) {
      Swal.fire({ icon:'error', title:'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = '';
    }
  };

  reader.readAsText(file, 'utf-8');
},
    error(n_error,extra=""){
        switch(n_error){
            case 1:
                this.error_msg="El csv debe contener las cabeceras de 'Horizonte' y 'Valor motores'";
                break;
                case 2:
            this.error_msg="No se ha encontrado el horizonte "+ extra + " en la matriz.";
                break;
                case 3:
                this.error_msg="No existe el horizonte: " +extra;
                break;
                case 4:
                   console.log("Caso 4");
                  break;
                case 5:
                  console.log("Caso 5");
                  break;
                case 6:
                  console.log("Caso 6");
                  break;
                case 7:
                  console.log("Caso 7");
                  break;
                case 8:
                  console.log("Caso 8");
                  break;
                case 9:
                  console.log("Caso 9");
                  break;
                case 10:
                  console.log("Caso 10");
                  break;
             
        }
        this.showAlert=true

       },

    exportToCSV() {
    try {
      const headers = HEADERS_OFICIALES_RO.join(';');

      // solo horizontes presentes en mesesUnicos
      const valoresFiltrados = Object.fromEntries(
        Object.entries(this.localValue).filter(([k]) => k in this.mesesUnicos)
      );

      const rows = Object.entries(valoresFiltrados).map(
        ([horizonte, valor]) => [horizonte, this.toCsvDecimalComma(valor, 2)].join(';')
      );

      const csv = [headers, ...rows].join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'RoCogeneracion.csv';
      a.click();
      URL.revokeObjectURL(url);

      Swal.fire({ icon:'success', title:'Exportación correcta', timer:1600, showConfirmButton:false });
    } catch (e) {
      Swal.fire({ icon:'error', title:'Error al exportar', text: e?.message || 'Revisa los datos.' });
    }
  },
    parseNumber(value) {
      if (!value) return 0;

      value = value.toString().trim();

      // Si contiene coma y no punto
      if (value.includes(',') && !value.includes('.')) {
        value = value.replace(/\./g, '');  // eliminar separadores de miles
        value = value.replace(',', '.');   // convertir coma decimal a punto
      }
      // Si contiene ambos
      else if (value.includes(',') && value.includes('.')) {
        if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
          value = value.replace(/\./g, '');
          value = value.replace(',', '.');
        } else {
          value = value.replace(/,/g, '');
        }
      }

      return parseFloat(value);
    }

  }
};
</script>

<style scoped>
/* Formato mensajes de información */
.backup-alert {
  max-width: 900px;
  width: 90%;
  color: #000 !important;                
  background-color: #F2F2F2;
  border: 2px solid #1776BF;
}
.texto-multilinea {
  white-space: pre-wrap !important;
}
.contenedor-tabla {
width: 100%;
/* margin: auto; */

}

.scroll-container {
width: 100%;
max-height: 500px;
overflow-x: auto;
overflow-y: auto;
/* border: 1px solid #D9D9D9; */
border-radius: 10px;
}

table {
width: 100%;
font-size:14px;
border-collapse: collapse;
text-align: center;
}
.cogeneracion-title{
background-color: #CDCDCD;
color: white;
}

.table-header {
font-size:14px;
font-weight: bold;
text-align: center;
margin-bottom: 10px;
color: white;
background-color: #686868;
 border-radius: 10px;
padding: 10px;
}

.encabezado_bold{
  font-size:14px;
}

.sticky-column {
position: sticky;
font-size:14px;
left: 0;
background-color: white;
z-index: 2;
}
/* .datos{
background-color: #F2F2F2;
} */

input[type="number"] {
width: 100%;
text-align: center;
border: none;
border-radius: 4px;
color: #024e74;
}

</style>

